<ul class="list-validate">
    <li [ngClass]="{'active': countChar }">
        <i></i>
        <span>
           {{'AUTH.VALIDATION.PASSWORD.COUNT_CHARACTER' | translate}}
        </span>
    </li>
    <li [ngClass]="{'active': hasCapitalCase }">
        <i></i>
        <span>
            {{'AUTH.VALIDATION.PASSWORD.UPPERCASE_LETTER' | translate}}
        </span>
    </li>
    <li [ngClass]="{'active': hasNumber }">
        <i></i>
        <span>
            {{'AUTH.VALIDATION.PASSWORD.HAS_NUMBER' | translate}}
        </span>
    </li>
</ul>